import React from 'react';
import './ContactPage.css';

const ContactPage = () => {
  return (
    // <div className="main-content">
    //   <div className="main-card">
        <div className="contact-container">
          <div className="contact-header">
            <h2 className="contact-title">
              Have questions or need assistance? Please don't hesitate to reach out. Our team is ready to support you.
            </h2>
          </div>
          <div className="contact-sections">
            <div className="contact-section">
              <h3 className="contact-subtitle">For General Inquiries & Support</h3>
              <div className="contact-info">
                <span>support@predimind.in</span>
              </div>
            </div>
            <div className="contact-section">
              <p className="contact-text">
                If you'd prefer to speak with someone in our team, you can call us at
              </p>
              <div className="contact-info">
                <span>+91-XXXXX-XXXXX</span>
              </div>
            </div>
            <div className="address-box">
              <h3 className="address-title">Registered Office Address</h3>
              <p className="address-text">
                C - Block, 5th Floor, IITM Research Park, Kanagam Road, TTTI<br />
                Taramani, Mambalam, Chennai- 600113, Tamil Nadu
              </p>
            </div>
          </div>
          <div className="policy-buttons">
            <button className="policy-button">T&C Policy</button>
            <button className="policy-button">Privacy Policy</button>
          </div>
        </div>
    //   </div>
    // </div>
  );
};

export default ContactPage; 